import {useState} from 'react';

// See https://reactjs.org/docs/uncontrolled-components.html for theory on controlled vs
// uncontrolled state

export default function useControllableState<T>(initial: T, controlled?: T): [T, SetState<T>] {
    const [state, setState] = useState<T>(initial);
    return [controlled || state, setState];
}
